module.exports = __webpack_public_path__ + "img/ac70d331-bea4-40f7-9e1a-93f57bb4cb1d.382f314e.png";